import { useEffect, useState } from "react";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modalHistorial } from "./ui/sweetAlerts";
import { customStyles, objStyleCol, paginationComponentOptions } from "../utils/Constants";
import { momentFecha } from "../utils/funciones";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataTable from "react-data-table-component";
import { getUno } from "../api/apis";
import Spinner from "./ui/Spinner";
import "../css/app.css";

const HistorialDeReingresos = () => {
  const [arrayTabla, setArrayTabla] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [pageTable, setPageTable] = useState(1);

  useEffect(() => {
    fetchUsers(pageTable);
  }, []);

  const fetchUsers = async page => {
    setLoading(true);
    const resp = await getUno("historialreingreso", { page: page, total_page: perPage }, {});

    setLoading(false);
    if (resp.data.status === "success") {
      setArrayTabla(resp.data.data);
      setTotalRows(resp.data.paginacion.total);
    }
  };
  const handlePageChange = page => {
    setPageTable(page);
  };
  const handlePerRowsChange = async newPerPage => {
    setPerPage(newPerPage);
  };

  useEffect(() => {
    fetchUsers(pageTable);
  }, [pageTable, perPage]);

  const levantarHistorial = async el => {
    const resp = await getUno("historialreingresosolicitud", { idSolicitud: el }, null);
    if (resp?.status === 200) {
      modalHistorial("Historial de reingreso", resp.data.data);
    }
  };

  const rtrnVerSolicitud = (row, levantarHistorial) => {
    return (
      <button className="btn btnAccion rounded-3 btn-primary btn-sm" data-bs-toggle="tooltip" title="Ver solicituddddddd" onClick={() => levantarHistorial(row.id)}>
        <FontAwesomeIcon icon={faEye} />
      </button>
    );
  };

  const columns = [
    {
      name: "N° Personal SAP",
      selector: row => (row.reeo_codigo_sap === null ? "---" : row.reeo_codigo_sap),
      style: objStyleCol,
      width: "110px",
    },
    {
      name: "Nombre",
      sortable: false,
      selector: row => row.nombre,
      wrap: true,
      width: "400px",
    },
    {
      name: "Rut",
      selector: row => row.identificacion,
      style: objStyleCol,
      width: "100px",
    },
    {
      name: "Fecha Ingreso",
      selector: row => momentFecha(row.fecha_ingreso.split(" ")[0]),
      style: objStyleCol,
      width: "110px",
    },
    {
      name: "Estado actual",
      sortable: false,
      selector: row => (row.id_solicitud_estado === 16 ? `${row.estado_actual} por ${row.responsable}` : row.estado_actual),
      wrap: true,
      minWidth: "200px",
    },
    {
      name: "Ver",
      cell: row => rtrnVerSolicitud(row, levantarHistorial),
      wrap: true,
      width: "60px",
      style: objStyleCol,
    },
  ];

  return (
    <div className="row">
      <div className="col-sm-12 ">
        <div className="card cardPestania">
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body contenedorTabla">
              {arrayTabla.length > 0 ? (
                <DataTable
                  title={false}
                  responsive={true}
                  columns={columns}
                  data={arrayTabla}
                  customStyles={customStyles}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationDefaultPage={pageTable}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationComponentOptions={paginationComponentOptions}
                  dense
                />
              ) : (
                <p className="h5 text-center my-5 titleMensajeSimple">No se encontraron registros</p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistorialDeReingresos;
